import type { CSSProperties } from "react";

export function getProjectInitials(name: string): string {
  // 2+ capital letters in name → use first two
  const caps = name.match(/[A-Z]/g);
  if (caps && caps.length >= 2) return caps[0] + caps[1];

  // 2+ words → first char of first two words
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase();

  // fallback: first two chars
  return name.slice(0, 2).toUpperCase();
}

const PALETTE = [
  "bg-indigo-500",
  "bg-violet-500",
  "bg-sky-500",
  "bg-emerald-500",
  "bg-amber-500",
  "bg-rose-500",
  "bg-teal-500",
  "bg-fuchsia-500",
];

export function getProjectColor(id: string): string {
  let hash = 0;
  for (const ch of id) hash = ((hash * 31) + ch.charCodeAt(0)) | 0;
  return PALETTE[Math.abs(hash) % PALETTE.length];
}

// Per-workspace accent hex (design-mock `w.accent`). Used for the active accent
// bar, the active circle's tint/border/glow, and the top-bar workspace icon — so
// peeking different workspaces shows their own colour, over a neutral fill.
const ACCENTS = [
  "#818cf8", // indigo
  "#a78bfa", // violet
  "#38bdf8", // sky
  "#34d399", // emerald
  "#fbbf24", // amber
  "#fb7185", // rose
  "#2dd4bf", // teal
  "#e879f9", // fuchsia
];

export function getProjectAccent(id: string): string {
  let hash = 0;
  for (const ch of id) hash = ((hash * 31) + ch.charCodeAt(0)) | 0;
  return ACCENTS[Math.abs(hash) % ACCENTS.length];
}

// Inline style for the active workspace circle badge (mock `circleStyle` active
// branch): faint accent tint + accent border + accent glow.
export function activeCircleStyle(accent: string): CSSProperties {
  return {
    backgroundColor: `${accent}26`,
    borderColor: accent,
    boxShadow: `0 0 18px -4px ${accent}88`,
  };
}
